/**
 * Réduit les fuites dans la console DevTools (dev uniquement via devLog).
 * Ne remplace pas le chiffrement : JWT dans localStorage / onglet Réseau restent visibles pour l’utilisateur.
 */

const SENSITIVE_KEY = (k) => {
  const lower = String(k).toLowerCase();
  if (
    lower === "authorization" ||
    lower === "password" ||
    lower === "secret" ||
    lower === "accesstoken" ||
    lower === "refresh_token" ||
    lower === "refreshtoken" ||
    lower === "id_token" ||
    lower === "idtoken" ||
    lower.endsWith("token")
  ) {
    return true;
  }
  return lower.includes("token") && !lower.includes("timeout");
};

/** Objet / tableau JSON-safe pour console : masque clés sensibles (récursion limitée). */
export function sanitizeDeep(value, depth = 0) {
  if (depth > 6) return "[…]";
  if (value === null || value === undefined) return value;
  const t = typeof value;
  if (t === "string") {
    if (value.length > 20 && value.startsWith("eyJ")) return "[JWT]";
    return value;
  }
  if (t === "number" || t === "boolean") return value;
  if (Array.isArray(value)) {
    return value.map((item) => sanitizeDeep(item, depth + 1));
  }
  if (t === "object") {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      out[k] = SENSITIVE_KEY(k) ? "[redacted]" : sanitizeDeep(v, depth + 1);
    }
    return out;
  }
  return "[…]";
}

/** Headers fetch : ne jamais logger Bearer tel quel. */
export function sanitizeHeaders(headers) {
  if (!headers || typeof headers !== "object") return headers;
  const copy = { ...headers };
  if (copy.Authorization) copy.Authorization = "Bearer [redacted]";
  if (copy.authorization) copy.authorization = "Bearer [redacted]";
  return copy;
}
